export const formatCurrency = (value, options = {}) => {
  const {
    currency = "USD",
    locale = "en-US",
    fallback = "$0.00",
  } = options;

  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return fallback;
  }

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default formatCurrency;